import { Observable, tap } from 'rxjs';
import { SeoService } from '@shared/helpers/seo.service';
import { TranslateService } from '@shared/translates/translate.service';

export function initLanguage(translateService: TranslateService, seoService: SeoService) {
  return (): Observable<void> =>
    translateService.initLanguage().pipe(
      tap(() => {
        seoService.setLanguage(translateService.currentLanguage);
      }),
    );
}
